// extracted by mini-css-extract-plugin
module.exports = {"title":"EditorHeader_title__22A8v"};